<ion-card
  class="quantity-selector-card"
  [ngClass]="{ 'quantity-selector-card-solid': fill === 'solid' }"
  [color]="color"
  mode="ios"
>
  <!-- * Botón de disminuir -->
  <section>
    <ng-container *ngIf="showRemoveBtn || quantity > minimo">
      <ion-button
        mode="ios"
        size="default"
        shape="round"
        [disabled]="quantity === minimo"
        (click)="onDecrease()"
        class="btn-selector"
        [attr.data-test]="'Automation.btn-card-decrease' | translate"
      >
        <ion-icon
          name="remove-circle-sharp"
          slot="icon-only"
          class="ic-selector"
        ></ion-icon>
      </ion-button>
    </ng-container>

    <!-- * Botón de eliminar -->
    <ng-container *ngIf="!showRemoveBtn && quantity === minimo">
      <ion-button
        mode="ios"
        size="default"
        shape="round"
        (click)="onRemove()"
        class="btn-selector"
      >
        <ion-icon
          name="getm-trash-fill"
          slot="icon-only"
          class="ic-trash"
        ></ion-icon>
      </ion-button>
    </ng-container>
  </section>

  <!-- Input de cantidad -->
  <ion-input
    [attr.data-test]="'Automation.txtbox-card-input' | translate"
    type="tel"
    inputmode="numeric"
    mode="md"
    [value]="quantity"
    [min]="minimo || 0"
    [max]="maximo || 100"
    minlength="1"
    maxlength="5"
    pattern="^[0-9]\d*$"
    readonly="true"
    required
    (ionInput)="onInputChange($event)"
    class="quantity-input"
    [style.max-width.ch]="quantity ? quantity.toString().length + 2 : 3"
  ></ion-input>

  <!-- * Botón de aumentar -->
  <ion-button
    mode="ios"
    size="default"
    shape="round"
    [disabled]="quantity >= maximo"
    (click)="onIncrease()"
    class="btn-selector"
  >
    <ion-icon
      name="add-circle-sharp"
      slot="icon-only"
      class="ic-selector"
    ></ion-icon>
  </ion-button>
</ion-card>
